import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import DeleteModal from "../../../components/Common/DeleteModal"
import { usePagination } from "../../../hooks/usePagination"
import ResultHandler from "../../../components/ResultHandler"
import PaginationHandler from "../../../components/PaginationHandler"
import { deleteDeduction, getDeductions, searchAndExport, importFile, importDeductions } from "../../../api/deductions"
import TableHeaderHandler from "../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../hooks/useResponse"
import TableAction from "../../../components/TableAction"
import EmptyData from "../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import moment from "moment"
import { calcPrice } from "./CONSTANT"
import { Badge, Button } from "reactstrap"
import { formatCurrency } from "../../../utils/formatCurrency"



export default function DeductionsTable() {

  const { t } = useTranslation()
  const navigate = useHistory()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta
  } = usePagination(getDeductions)

  //// delete 
  const [show, setShow] = useState(false)
  const [deletingDeduction, setDeletingDeduction] = useState(null)

  const { setData } = useResponse(deleteDeduction, () => {
    setShow(false)
    setDeletingDeduction(null)
    setPayload({})
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingDeduction })
  }


  function onCloseClick() {
    setShow(false)
  }
  


  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.DEDUCTIONS_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="/add-deduction"
      >
     
      </TableHeaderHandler>
   

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Employee</Th>
                <Th>Price</Th>
                <Th>Paid</Th>

                <Th style={{ width: "15%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.deductions.map(row => {
                  return (
                    <Tr key={row.id}>
                        <Td>
                        {row.employee?.name}
                      </Td>
                      <Td>
                        {formatCurrency(row.amount)}
                      </Td>
                      <Td>
                        <Badge color={row.payslipeId ? "success" : "danger"}>
                          {row.payslipeId ? "PAID" : "NOT PAID"}
                        </Badge>
                      </Td>
                      <Td>
                        <TableAction
                          hasDelete={true}
                          deletePermission={PERMISSIONS.DEDUCTIONS_DELETE}
                          type="deduction"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingDeduction}
                        />
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.deductions.length === 0} msg="No Deductions Found." />
          }
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />


          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}


     
          <ResultHandler error={error} loading={loading} />

        </div>
      </div>
    </>
  )
}
